import React from "react";
import ReactDOM from "react-dom";
import App from "./routes/App";
import * as serviceWorker from "./serviceWorker";
import AppService from "s2s-app-service";
//import { createStore } from "redux";

import { BrowserRouter as Router } from "react-router-dom";

import { StoreProvider } from "./js/store";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import npm_package from "./../package.json";

//import myStoreStuff from './store/index';

// import { Provider } from "react-redux";
// import actions, { auto, reducers } from "redux-auto";

// ******************************
// **** Sentry Section  ****
// ******************************
const env = location.hostname.indexOf('localhost') > -1 ? "development" : (location.hostname.indexOf(".com") > -1 ? "production" : "test");
const BrowserTracing = new Integrations.BrowserTracing();
Sentry.init({
  dsn: 'https://4c249075b60c42e9a427bcbeaf8a389b@o384411.ingest.sentry.io/5853357',
  integrations: [BrowserTracing],
  tracesSampleRate: env === "production" ? 0.1 : 1.0,
  environment: env,
  release: npm_package.version,
});

// const storeModules = require.context("./store", true, /\.js$/);
// const reducers = require.context("./reducers", true, /\.js$/);

// ******************************
// ****      THE STORE       ****
// ******************************
//const store = createStore(myStoreStuff);

// ******************************
// **** Internationalization ****
// ******************************
// actions.app.setLanguage({});

// ******************************
// ****   Theming Section    ****
// ******************************
// actions.app.setUITheme();

// ******************************
// ****   matchMedia setup   ****
// ******************************
// setupDynamicMatchMedia();

// ******************************
// **** AppServices Section  ****
// ******************************
try {
  const doRender = () => {
    // dev mode setup some stuff
    /* eslint no-restricted-globals: off */
    if (location.href.indexOf("localhost:") > -1) {
      console.log("DEV MODE  -  setting up global variables;   appService ");
      //window.theStore = useStore();
      window.appService = appService;
      // window.actions = actions;
    }

    // ReactDOM.render(<Provider store={store} ><App /></Provider>, document.getElementById('root'));
    ReactDOM.render(
      <StoreProvider initialValue={undefined}>
        <Router>
          <App />
        </Router>
      </StoreProvider>,
      document.getElementById("root")
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.register();
  };

  const appService = AppService.getInstance();

  appService
    .setApplicationName(window._env_.applicationName)
    .setWebsocketHost(window._env_.websocketHost)
    .setTLS(window._env_.useTLS)
    .addS2SService("websocket")
    .addPubSubEvents("identity")
    .addPubSubEvents("voicemail")
    .addS2SService("call");

  // always try to reconnect with the data we have.
  let connectData = appService.getConnectData();
  const isUpdate = location.pathname === "/update" ? true : false;
  if (connectData.account.uuid !== "-1" && !isUpdate) {
    appService
      .reconnect()
      .then(async () => {
        // this could be all inside app service?
        appService.getCallService().setAvailableExtensions(
          appService.getConnectData().available_extensions
        );
        await appService.
        getCallService().s2sLogin(appService.getConnectData().current_extension);
        doRender();
      })
      .catch((e) => {
        throw e;
      });
  } else {
    doRender();
  }
} catch (e) {
  console.log(e);
}
